/* ========== ~~~~~~~~~~ TRANSILER : SETTINGS ~~~~~~~~~~ ========== */
export const settings = {
    project: 'mks',
    client: {
        uuid: "11a24129-a3dc-42bd-afea-c2eb71dfb955"
    },
    site: {
        uuid: "ca9a3b5a-e0ae-409f-b332-306d751fa9c9",
        url: "http://testthisshit.online/",
        category: "IAB1"
    },
    embed: {
        uuid: "7c38c998-7e02-44de-a9dc-56bb1d2d7147",
        name: "rail",
        version: "4.0",
        type: "hardcoded",
        location: "rail",
        date: { created: 1455175477000, updated: 1455175477000 },
        inView: 'none',
        isPubPortalPreview: true,
        googleAnalyticsID: 'UA-117639106-1',
        brandColor: '#dc3434',
        ads: {
            display: {
                desktop: "REGULAR", // REGULAR, OVERLAY_TOP_AD, OVERLAY_BOTTOM_AD, BOTH_OVERLAY_ADS
                mobile: "REGULAR" // REGULAR, OVERLAY_TOP_AD, OVERLAY_BOTTOM_AD, BOTH_OVERLAY_ADS
            }
        },
        rewards: {
            enabled: false,
            pointValues: {
                quiz: 2,
                poll: 2,
                profile: 5,
                marketResearch: {
                    cint: 100,
                    lucid: 100,
                    pollfish: 100
                }
            },
            redeemAfter: 1000,
            monetaryValue: '$10'
        },
        styles: {
            desktop: {
                width: '100%',
                height: '350px'
            },
            mobile: {
                width: '100%',
                height: '350px'
            }
        },
        elements: {
            partnerLogo: {
                text: "theoriginals",
                src: "theoriginals/logo-theoriginals.png",
                url: "http://theoriginalsonline.com/"
            }
        },
        content: [
            {
                id: "24SplashScreen34",
                type: "splash",
                isCollection: false,
                queuePosition: null,
                whenToFetch: null, // 'onEmbedLoad', 'onContentLoad', 'onPrevContentFirstFrame', 'onPrevContentMidFrame', 'onPrevContentLastFrame'
                showFrameForXSeconds: null, // means we're waiting for user action or app flow to move off of this screen
                canSkipFrames: false,
                killInjectablesOnCompletion: false,
                uniqueProps: {},
                styles: { width: '100%', height: '100%' },
                elements: {
                    companyLogo: { visible: true, text: "powered by" }
                },
                injectables: []
            },
            {
                id: "2342lkjMixedContentTest", // unique ID for each piece of content (needed to handle the concept of injecting one piece of content into another)
                type: "mixed", // [trivia, poll, article, contest, ad, etc], content type
                isCollection: true,
                queuePosition: 0, // [null, numValue], position of content in queue (used to execute content in a specific order)
                whenToFetch: null, // 'onEmbedLoad', 'onContentLoad', 'onPrevContentFirstFrame', 'onPrevContentMidFrame', 'onPrevContentLastFrame'
                showFrameForXSeconds: null, // [null, numValue], how long each frame of this content shows until moving to the next (in milliseconds) ... null indicates user action or app flow prompting movement
                canSkipFrames: true,
                killInjectablesOnCompletion: true,
                uniqueProps: { showResultForXSeconds: 5000, showRewardsPhaseForXSeconds: null, framesOrder: "ordered", numberOfQuestionsLimit: 10 },
                styles: { width: '100%', height: '100%' },
                elements: {
                    header: { indicator: { visible: true }, partnerLogo: { visible: true } },
                    footer: { learnmore: { visible: true }, companyLogo: { visible: true }, heart: { visible: true } }
                },
                injectables: [
                    { id: "24SplashScreen34", type: "content", injectAtFrame: 0, repeatEveryXFrames: null, removeAtFrame: null, pauseType: "parent", location: "main", size: "100%", closeCTA: false, displayType: "overlay modal" },
                    { id: "234dfAd1", type: "content", injectAtFrame: 0, repeatEveryXFrames: null, removeAtFrame: null, pauseType: "parent", location: "main", size: "100%", closeCTA: false, displayType: "overlay modal" },
                    { id: "udc-01", type: "content", injectAtFrame: null, repeatEveryXFrames: null, removeAtFrame: null, pauseType: "parent", location: "main", size: "100%", closeCTA: false, displayType: "overlay modal" },
                ]
            },
            // {
            //     id: "questionnaire-01",
            //     type: "questionnaire",
            //     queuePosition: 1,
            //     isCollection: false,
            //     whenToFetch: null,
            //     showFrameForXSeconds: null,
            //     canSkipFrames: false,
            //     killInjectablesOnCompletion: true,
            //     uniqueProps: {
            //         onStartScreens: ['questionnaireOptin', 'questionnaireAbout'],  // order matters, screens will be shown one after another. [] to disable screens.
            //         onCompleteScreens: ['questionnaireComplete'],
            //         showCoverScreens: true, // shows a cover screen with questions number and points value information for each questionnaire
            //         showResultForXSeconds:2000,
            //         showRewardsPhaseForXSeconds:null,
            //         questionnaireType: 'DEMOGRAPHIC', // lifestyle
            //         numberOfQuestions: 20,
            //         numberOfQuestionnaires: 5,
            //     },
            //     styles: { width: "100%", height: "100%"},
            //     elements: {
            //         header: { indicator: { visible: true }, partnerLogo: { visible: true } },
            //         footer: { learnmore: { visible: true }, companyLogo: { visible: true }, heart: { visible: true } }
            //     },
            //     injectables: []
            // },
            {
                id: "udc-01",
                type: "userDataCollection",
                queuePosition: 1,
                isCollection: false,
                whenToFetch: null,
                showFrameForXSeconds: null,
                canSkipFrames: true,
                killInjectablesOnCompletion: true,
                uniqueProps: {
                },
                styles: {
                    width: "100%",
                    height: "100%"
                },
                elements: {
                    header: {
                        indicator: {
                            visible: true
                        },
                        partnerLogo: {
                            visible: true
                        }
                    },
                    footer: {
                        learnmore: {
                            visible: true
                        },
                        companyLogo: {
                            visible: true,
                        }
                    }
                },
                injectables: []
            },
            {
                id: "234dfAd1",
                type: "ad",
                isCollection: false,
                queuePosition: null,
                whenToFetch: null, // 'onEmbedLoad', 'onContentLoad', 'onPrevContentFirstFrame', 'onPrevContentMidFrame', 'onPrevContentLastFrame'
                showFrameForXSeconds: 15000, // means we're waiting for user action or app flow to move off of this screen
                canSkipFrames: true,
                killInjectablesOnCompletion: false,
                uniqueProps: {},
                styles: { width: '100%', height: '100%' },
                elements: {
                    header: { indicator: { visible: true }, partnerLogo: { visible: true } },
                    footer: { learnmore: { visible: true }, companyLogo: { visible: true }, heart: { visible: true } }
                },
                injectables: []
            }
        ]
    }
};
